module.exports = "/static/assets/c252c7ab1395a3a602cbcaeb19e6b928.png";